import store from '@/store/store';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import {Route} from 'vue-router';
import {graphqlClient} from '@/store/apollo/apollo';

export function createAuthUrl(referral: string) {
  if (!referral.startsWith('http')) {
    referral = process.env.VUE_APP_DOMAIN + referral;
  }
  return process.env.VUE_APP_AUTH_ENDPOINT + '?continue=' + referral;
}

@Module
export default class Authentication extends VuexModule {
  protected account: any | null = null;
  protected permissions: string[] = [];

  get isLoggedIn(): boolean {
    return this.account !== null && this.permissions.includes('view-grip');
  }

  get user(): any {
    return this.account;
  }

  get can() {
    return (value: string | string[]): boolean => {
      if (Array.isArray(value)) {
        return value.every((permission: string) => {
          return permission.split('|').some((p: string) => {
            return this.permissions.indexOf(p) >= 0;
          });
        });
      } else {
        return this.permissions.indexOf(value) >= 0;
      }
    };
  }

  @Action({})
  private authorize(to: Route) {
    return new Promise((resolve, reject) => {
      if (this.isLoggedIn) {
        return resolve();
      }
      return reject();
    }).catch(() => {
      store.dispatch('deleteToken')
        .then(() => {
          window.location.href = createAuthUrl(to.fullPath);
        });
    });
  }

  @Action({commit: 'clear'})
  private logout(referral: string) {
    store.dispatch('deleteToken')
      .then(() => {
        window.location.href = createAuthUrl(referral);
      });
  }

  @Action({commit: 'clear'})
  private deleteToken() {
    return true;
  }

  @Action({commit: 'setAccount'})
  private async resolveAccount() {
    const me = await graphqlClient.query({
      query: require('@/graphql/Me.graphql'),
    }).catch(() => {
      return null;
    });

    return me && me.data.me;
  }

  @Mutation
  private async setAccount(account: any) {
    this.account = account;
    this.permissions = [];
    if (this.account !== null) {
      this.permissions = JSON.parse(this.account.rights);
    }
  }

  @Mutation
  private clear() {
    this.account = null;
    this.permissions = [];
  }
}

